import { render } from "./appointments.vue?vue&type=template&id=7ace4afd"
import script from "./appointments.vue?vue&type=script&lang=js"
export * from "./appointments.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/widgets/appointments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ace4afd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ace4afd', __exports__)) {
    console.log('reload')
    api.reload('7ace4afd', __exports__)
  }
  
  module.hot.accept("./appointments.vue?vue&type=template&id=7ace4afd", () => {
    console.log('re-render')
    api.rerender('7ace4afd', render)
  })

}


export default __exports__